import classNames from 'classnames'

import eventStyles from '../styles.module.scss'

const EventDateInfo = ({ event, selectedEvent }) => (
    <div
        className={classNames(
            eventStyles.eventDateInfo,
            selectedEvent === event && eventStyles.eventSelected,
            event.isSoldOut && eventStyles.disabled
        )}>
        <div className={eventStyles.eventDate}>
            <span className={eventStyles.eventDateLabel}>
                <T>booking.review.pay.data.start</T>
            </span>
            <span>{event?.fromDate.format('ddd, MMMM D, YYYY h:mm A')}</span>
        </div>
        <div className={eventStyles.eventDate}>
            <span className={eventStyles.eventDateLabel}>
                <T>booking.review.pay.data.end</T>
            </span>
            <span>{event?.toDate.format('ddd, MMMM D, YYYY h:mm A')}</span>
        </div>
    </div>
)

export default EventDateInfo
